import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message, loading }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[110] flex items-center justify-center p-4 bg-slate-900/20 backdrop-blur-md animate-in fade-in duration-300" onClick={onClose}>
            <div className="bg-white rounded-3xl w-full max-w-md overflow-hidden shadow-[0_25px_50px_-12px_rgba(0,0,0,0.1)] border border-slate-100 transform transition-all animate-premium" onClick={(e) => e.stopPropagation()}>
                <div className="p-8 text-center">
                    <div className="w-16 h-16 bg-rose-50 text-rose-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
                        <FaExclamationTriangle size={24} />
                    </div>

                    <h3 className="text-xl font-black text-slate-900 mb-2 uppercase tracking-tight">
                        {title || 'Confirm Action'}
                    </h3>

                    <p className="text-slate-400 text-sm mb-8 font-bold leading-relaxed">
                        {message || 'Are you sure you want to proceed? This action cannot be undone.'}
                    </p>

                    <div className="grid grid-cols-2 gap-3">
                        <button
                            onClick={onClose}
                            disabled={loading}
                            className="px-5 py-3.5 text-slate-500 font-black text-[10px] uppercase tracking-widest hover:bg-slate-50 rounded-2xl transition-all border border-slate-100 bg-white"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={onConfirm}
                            disabled={loading}
                            className="px-5 py-3.5 bg-rose-500 hover:bg-rose-600 text-white font-black text-[10px] uppercase tracking-widest rounded-2xl transition-all shadow-lg shadow-rose-500/20 flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
                        >
                            {loading ? (
                                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                            ) : (
                                'Confirm Delete'
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
